import React from 'react';
import { statuses } from '../../Data/Jobs';
import Dropdown from '../../Components/Dropdown';
import Services from '../../Components/Formatting/Services';
import Title from '../../Components/Formatting/Customer/Title';
import Subtitle from '../../Components/Formatting/Customer/Subtitle';
import Badge from '../../Components/Badge/Badge';
import { classNames, getEntityLink } from '../../Services/helpers';
import { useDialogues } from '../../Components/Dialogues';
import DateTime from '../../Components/Formatting/DateTime';
import { SelectBox, useSelectable } from '../../Components/Selectable';
import { Transition } from '@headlessui/react'
import Tags from '../../Components/Tags/Tags';
import { useSession } from '../../Components/Session';

const Job = ({job, setScheduling, setMarkingAsDone, setSkipping, setEditing, deleteJob, refresh}) => {
    const {confirm} = useDialogues();
    const {isSelecting, toggleSelected} = useSelectable();
    const {hasFeature} = useSession();

    // Clicking the full row should toggle, but we don't want to click the checkbox/dropdown area when not selecting
    const onClick = (isFullRowClick) => {
        if (isSelecting && isFullRowClick) {
            toggleSelected(`${job.customerId}-${job.id}`);
        } else if (isFullRowClick === false && isSelecting === false) {
            setScheduling(job);
        }
    }

    return <li className="flex items-center justify-between py-5" onClick={() => onClick(true)}>
        <Transition
            show={isSelecting}
        >
            <div className={classNames(
                'flex flex-none items-center px-4',
                // Base styles
                'transition ease-in-out duration-150 overflow-hidden max-w-[100px]',
                // Shared closed styles
                'data-[closed]:opacity-0 data-[closed]:max-w-0',
            )}>
                <SelectBox id={`${job.customerId}-${job.id}`} />
            </div>
        </Transition>
        <div className="grow" onClick={() => onClick(false)}>
            <p className="text-sm leading-6 text-gray-900 font-semibold">
                {job.title ?? '#'+job.shortId}
                <Badge className={classNames(statuses[job.status].bgColor, statuses[job.status].contrastTextColor, 'ml-4')}
                    title={job.status}
                />
            </p>
            <p className="my-1">
                <strong><Title customer={job.customer} /></strong><br />
                <Subtitle customer={job.customer} />
            </p>
            <p className="my-1">{job.title ?? <Services services={job.services} />}</p>
            {(hasFeature('TAGS') && job.tags?.length) && <p className="my-1"><Tags tags={job.tags} /></p>}
            <p className="mt-2 text-muted"><DateTime date={job.scheduledDate} hideTime blank="Not scheduled" /></p>
        </div>

        <Dropdown
            disabled={isSelecting}
            options={[
                {title: 'View customer', icon: 'User', to: getEntityLink('Customers/Customer', job.customer.id)},
                {div: true},
                {title: 'Schedule job', icon: 'CalendarPlus', onClick: () => setScheduling(job)},
                {title: 'Mark as done', icon: 'Check', onClick: () => setMarkingAsDone(job)},
                {title: 'Skip job', icon: 'Forward', onClick: () => setSkipping(job)},
                {div: true},
                {title: 'Edit job', icon: 'Pencil', onClick: () => setEditing(job)},
                {title: 'Delete job', icon: 'Trash', onClick: () => confirm(
                    {
                        theme: 'danger',
                        title: 'Delete job #'+job.shortId,
                        confirmLabel: 'Delete',
                        message: 'Are you sure you want to delete this job? This cannot be undone.',
                    },
                    () => deleteJob(job).then(refresh),
                )},
            ]}
        />

    </li>
}

export default Job;